import React from "react";
// import {
//   Banner,
//   HomeCourses,
//   HowMyCoursesWork,
//   Reviews,
// } from "../../../components/Web";

export function ErrorAccessDenied() {
  return (
    <div>
      <h2>Acceso denegado</h2>
    </div>
  );
}
